// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2mw9S","search":"Settings_search__7jvl_","filter":"Settings_filter__1Jp4G"};